import React, { useState, useEffect } from 'react';
import JsBarcode from 'jsbarcode';
import { createCanvas } from 'canvas';

const FardForm = () => {
    const [formData, setFormData] = useState({
        sr_no: '',
        book_no: '',
        news_no: '',
        no: '',
        thana: '',
        district: '',
        time: '',
        r_date: '',
        r_time: '',
        name_news: '',
        crime: '',
        d_date: '',
        criminal_loc: '',
        d_time: '',
        phone_no: '',
        token_id: 'E-Fard - ',
        place: '',
        date: '',
        remarks: '',
        status_f: '',
        status_c: '',
        under_inquiry: '',
        paid_quiry: '',
        weapon: '',
        witness: '',
        crime_news: '',
        name: '',
        count: '',
        khasra: '',
        rakba: '',
        malia: '',
        qism: '',
        fees: '',
        report: '',
        operation: ''
    });

    const [message, setMessage] = useState(null);
    const [barcodeImage, setBarcodeImage] = useState(null);
    const [showPopup, setShowPopup] = useState(false);

    const generateBarcode = (token_Id) => {
        const canvas = createCanvas();
        JsBarcode(canvas, token_Id, { format: "CODE128" });
        return canvas.toDataURL("image/png");
    };

    useEffect(() => {
        if (formData.token_id) {
            const barcodeImage = generateBarcode(formData.token_id);
            setBarcodeImage(barcodeImage);
        } else {
            setBarcodeImage(null);
        }
    }, [formData.token_id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.token_id) {
            setMessage("براہ کرم ضروری فیلڈز بھریں");
            return;
        }

        try {
            const response = await fetch('https://chaman.gob.pk/eac_backend/fard.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    action: 'add',
                    ...formData,
                    barcode: barcodeImage
                })
            });

            const result = await response.json();
            if (result.status === "success") {
                setMessage(result.message);
                setFormData({
                    sr_no: '',
                    book_no: '',
                    news_no: '',
                    no: '',
                    thana: '',
                    district: '',
                    date: '',
                    time: '',
                    r_date: '',
                    r_time: '',
                    name_news: '',
                    crime: '',
                    place: '',
                    criminal_loc: '',
                    operation: '',
                    d_date: '',
                    d_time: '',
                    remarks: '',
                    phone_no: '',
                    token_id: '',
                    status_f: '',
                    status_c: '',
                    under_inquiry: '',
                    paid_quiry: '',
                    weapon: '',
                    witness: '',
                    crime_news: '',
                    name: '',
                    count: '',
                    khasra: '',
                    rakba: '',
                    malia: '',
                    qism: '',
                    fees: '',
                    report: ''
                });
                setBarcodeImage(null);
                setShowPopup(true);
                setTimeout(() => setShowPopup(false), 2000);
            } else {
                setMessage("خرابی: " + result.message);
            }
        } catch (error) {
            console.error("فارم جمع کرانے میں خرابی:", error);
            setMessage("فارم جمع کرانے کے دوران ایک خرابی پیش آئی۔ براہ کرم دوبارہ کوشش کریں۔");
        }
    };

    return (
        <div className="lc-form-container" style={{ direction: 'rtl' }}>
            <form className="lc-formfir" onSubmit={handleSubmit}>
                <div className="lc-left-section">
                <div className='lc-form-group'>
                        <label className='lc-label'>ٹوکن آئی ڈی:</label>
                        <div className="lc-input-container">
                            <input
                                className='lc-input'
                                type="text"
                                name="token_id"
                                value={formData.token_id}
                                onChange={handleChange}
                                required
                            />
                        </div>
                    </div>

                    <div className='lc-form-group'>
                        <label className='lc-label'>تاریخ:</label>
                        <div className="lc-input-container">
                            <input
                                className='lc-input'
                                type="date"
                                name="sr_no"
                                value={formData.sr_no}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div className='lc-form-group'>
                        <label className='lc-label'>نقل فرد حقیت از:</label>
                        <div className="lc-input-container">
                            <input
                                className='lc-input'
                                type="text"
                                name="place"
                                value={formData.place}
                                onChange={handleChange}
                            />
                        </div>
                    </div>
                    <div className='lc-form-group'>
                        <label className='lc-label'>نمبر گھتونی:</label>
                        <div className="lc-input-container">
                            <input
                                className='lc-input'
                                type="text"
                                name="crime_news"
                                value={formData.crime_news}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div className='lc-form-group'>
                        <label className='lc-label'>نام مالک معہ احوال:</label>
                        <div className="lc-input-container">
                            <input
                                className='lc-input'
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div className='lc-form-group'>
                        <label className='lc-label'>نام بزگر معہ احوال:</label>
                        <div className="lc-input-container">
                            <input
                                className='lc-input'
                                type="text"
                                name="count"
                                value={formData.count}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div className='lc-form-group'>
                        <label className='lc-label'>پیمانہ حقیقیت:</label>
                        <div className="lc-input-container">
                            <input
                                className='lc-input'
                                type="text"
                                name="khasra"
                                value={formData.khasra}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div className='lc-form-group'>
                        <label className='lc-label'>نمبر خسرہ:</label>
                        <div className="lc-input-container">
                            <input
                                className='lc-input'
                                type="text"
                                name="rakba"
                                value={formData.rakba}
                                onChange={handleChange}
                            />
                        </div>
                    </div>
                    <div className='lc-form-group'>
                        <label className='lc-label'>سال:</label>
                        <div className="lc-input-container">
                            <input
                                className='lc-input'
                                type="text"
                                name="weapon"
                                value={formData.weapon}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div className='lc-form-group'>
                        <label className='lc-label'>نمبر کھیوٹ:</label>
                        <div className="lc-input-container">
                            <input
                                className='lc-input'
                                type="text"
                                name="witness"
                                value={formData.witness}
                                onChange={handleChange}
                            />
                        </div>
                    </div>
                </div>

                <div className="lc-right-section">
                <div className='lc-form-group'>
                        <label className='lc-label'>محال:</label>
                        <div className="lc-input-container">
                            <input
                                className='lc-input'
                                type="text"
                                name="remarks"
                                value={formData.remarks}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div className='lc-form-group'>
                        <label className='lc-label'>موضع:</label>
                        <div className="lc-input-container">
                            <input
                                className='lc-input'
                                type="text"
                                name="status_f"
                                value={formData.status_f}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div className='lc-form-group'>
                        <label className='lc-label'>تپہ:</label>
                        <div className="lc-input-container">
                            <input
                                className='lc-input'
                                type="text"
                                name="status_c"
                                value={formData.status_c}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div className='lc-form-group'>
                        <label className='lc-label'>تحصیل:</label>
                        <div className="lc-input-container">
                            <input
                                className='lc-input'
                                type="text"
                                name="under_inquiry"
                                value={formData.under_inquiry}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div className='lc-form-group'>
                        <label className='lc-label'>ضلع:</label>
                        <div className="lc-input-container">
                            <input
                                className='lc-input'
                                type="text"
                                name="paid_quiry"
                                value={formData.paid_quiry}
                                onChange={handleChange}
                            />
                        </div>
                    </div>
                    <div className='lc-form-group'>
                        <label className='lc-label'>رقبہ:</label>
                        <div className="lc-input-container">
                            <input
                                className='lc-input'
                                type="text"
                                name="malia"
                                value={formData.malia}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div className='lc-form-group'>
                        <label className='lc-label'>قسم زمین:</label>
                        <div className="lc-input-container">
                            <input
                                className='lc-input'
                                type="text"
                                name="qism"
                                value={formData.qism}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div className='lc-form-group'>
                        <label className='lc-label'>مالیہ:</label>
                        <div className="lc-input-container">
                            <input
                                className='lc-input'
                                type="text"
                                name="fees"
                                value={formData.fees}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div className='lc-form-group'>
                        <label className='lc-label'>کیفیت:</label>
                        <div className="lc-input-container">
                            <input
                                className='lc-input'
                                type="text"
                                name="report"
                                value={formData.report}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div className='lc-form-group'>
                        <label className='lc-label'>بحوالہ انتقال نمبر:</label>
                        <div className="lc-input-container">
                            <input
                                className='lc-input'
                                type="text"
                                name="operation"
                                value={formData.operation}
                                onChange={handleChange}
                            />
                        </div>
                    </div>
                </div>
            </form>
                <button
                type="submit"
                className="lc-submit-btn"
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "8px"
                }}
            >
                {/* <i className="fas fa-save"></i> */}
                <span>Save</span>
            </button>

            {showPopup && (
                <div className="lc-popup">
                    Data Saved Successfully !
                </div>
            )}
        </div>
    );
};

export default FardForm;